var _path, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalCreditCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4V2H2V4H18ZM18 8H2V14H18V8ZM0 2C0 0.9 0.9 0 2 0H18C18.5304 0 19.0391 0.210714 19.4142 0.585786C19.7893 0.960859 20 1.46957 20 2V14C20 14.5304 19.7893 15.0391 19.4142 15.4142C19.0391 15.7893 18.5304 16 18 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V2ZM4 10H8V12H4V10Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 15,
    r: 7,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1202_1539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 13.5C17.5 13.1022 17.658 12.7206 17.9393 12.4393C18.2206 12.158 18.6022 12 19 12C19.3978 12 19.7794 12.158 20.0607 12.4393C20.342 12.7206 20.5 13.1022 20.5 13.5V14.1C20.5 14.4978 20.342 14.8794 20.0607 15.1607C19.7794 15.442 19.3978 15.6 19 15.6C18.6022 15.6 18.2206 15.442 17.9393 15.1607C17.658 14.8794 17.5 14.4978 17.5 14.1V13.5ZM16 17.004C16.9116 16.476 17.9466 16.1986 19 16.2C20.092 16.2 21.118 16.491 22 17.004V18H16V17.004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1202_1539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(16 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalCreditCart);
export default __webpack_public_path__ + "static/media/personalCreditCart.9b10e314682f7eb34b5df900be4d61e4.svg";
export { ForwardRef as ReactComponent };